import Icon from '../components/Icon.vue'

Icon.register({"angle-down":{"width":1152,"height":1792,"paths":[{"d":"M1075 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-down.js
// module id = 100
// module chunks = 0